<template>
  <component
      class="card-body pt-5 px-5 pb-3"
      :is="isFragment ? 'fragment' : 'div' ">
    <h5
        class="card-title font-weight-bold mb-3"
        v-if="exibeTitulo">
      {{ $t(titulo) }}
    </h5>
    <b-alert
        v-if="noContent && loaded"
        show
        variant="warning">
      <div class="d-flex justify-content-start">
        <i class="material-icons mr-2">
          error_outline
        </i>
        <div
            class="mt-1"
            v-html="$t(noContentMsg)" />
      </div>
    </b-alert>

    <HcFiltro
        id="areas-filtro"
        @filtrar="onFiltrar"
        @limpar="onLimpar"
        :exibe-filtro="exibeFiltro && !noContent"
        :titulo="$tc('label.pesquisar', $t(titulo))"
        :filtrar-text="$t('label.filtrar')"
        :limpar-text="$t('label.limpar')"
        :busca-avancada-text="$t('label.busca_avancada')"
    >
      <template slot="filtro-comum">
        <!--
            @slot filtro-comum
            destina a injetar um filtro no template, caso não implementado usará o default do Filtro.vue
          -->
        <slot name="filtro-comum" />
      </template>

      <template slot="botao-acao-comum">
        <!--
            @slot botao-acao-comum
            destina a injetar um botão de ação no template, não existe uma implementação default no Filtro.vue
          -->
        <slot name="botao-acao-comum">
          <div class="text-right">
            <b-button
                @click="onAdicionarClick"
                class="btn btn-primary btn-add mb-2">
              <i class="material-icons float-left mr-2">
                add
              </i>
              {{ $tc('label.novo_registro', titulo) }}
            </b-button>
            <b-button
                v-if="exibeExport"
                @click="onExportClick"
                class="btn-add-outline mb-2"
                variant="outline-primary"
                :titulo="$tc('label.export', $t(titulo))">
              <b-icon
                  icon="cloud-download"
                  aria-hidden="true"></b-icon>
            </b-button>
          </div>
        </slot>
      </template>
    </HcFiltro>
    <TabelaPadrao
        v-if="!noContent"
        ref="table"
        :pagina="pagina"
        :colunas="colunas"
        @ordenar="onOrdenar"
        @trocaPagina="onTrocaPagina"
        :exibeAcoes="true"
        :abrirLinha="abrirLinha"
        @abrir-linha="onAbrirLinha"
        :click-item="clickItem"
        @click-item="onClickItem"
        :mantem-estado="mantemEstado"
    >
      <template v-slot:row-content="{ item }">
        <!--
          @slot row-content
          destina a injetar o template de colunas na tabela padrão, implementação default na TabelaPadrao.vue
        -->
        <slot
            :item="item"
            name="row-content" />
      </template>

      <template v-slot:tbody="{ pagina }">
        <!--
          @slot tbody
          destina a injetar o template de tbody na tabela padrão, implementação default na TabelaPadrao.vue
        -->
        <slot
            :pagina="pagina"
            name="tbody" />
      </template>

      <template v-slot:acoes="{ item }">
        <!--
          @slot acoes
          destina a injetar o template de ações na coluna ações ta tabela padrão, não existe uma implementação default na TabelaPadrao.vue
        -->
        <slot
            :item="item"
            name="acoes">
          <AcoesDropDown
              :ativo-prop="ativoProp"
              :id-prop="idProp"
              :item="item"
              @editar="_onEditar"
              @toogle="onRemoverToogle($event, item)"
              :permite-editar="permiteEditar" />
        </slot>
      </template>
    </TabelaPadrao>
  </component>
</template>

<script>
import TabelaPadrao from '../tabela/TabelaPadrao';
import ModalConfirmacao from '../modal/ModalConfirmacao';
import { HcFiltro } from '../containers';
import { NovaPagina } from '../tabela';
import { ModalPequeno } from '../modal';
import AcoesDropDown from './AcoesDropDown';
import { BIcon }  from 'bootstrap-vue';
import { options } from '../index'

/**
 * Tela de listar padrão podendo ter filtros,
 * edição, colunas dinâmicas e etc.
 */
export default {
  components: {
    AcoesDropDown,
    TabelaPadrao,
    HcFiltro,
    BIcon
  },
  model: {
    prop: 'filtro',
    event: 'filtrar'
  },
  props: {
    filtro: Object,
    colunasExport: {
      type: Array,
      default: () => []
    },
    mantemEstado: {
      type: Boolean,
      default: false
    },
    noContentMsg: {
      type: String,
      default: 'msg.no_content'
    },
    isFragment: Boolean,
    apiPath: String,
    /**
     * Define se a tabela exibe export ou não
     * @values {boolean} true, false
     */
    exibeExport: {
      type: Boolean,
      default: () => {
        console.log( 'export' , options)
        if( options && options.tabela && options.tabela.exibeExport != undefined ){
          return options.tabela.exibeExport;
        }
        return true;
      }
    },
    /**
     * Define se a tabela exibe filtros ou não
     * @values {boolean} true, false
     */
    exibeFiltro: {
      type: Boolean,
      default: () => {
        console.log( 'exibeFiltro' , options)
        if( options && options.tabela && options.tabela.exibeFiltro != undefined ){
          return options.tabela.exibeFiltro;
        }
        return true;
      }
    },
    /**
     * ID que será usado na chamada GET
     * para popular a tabela
     * @values {String}
     */
    id: {
      type: String,
      default: 'tela-listar-padrao'
    },
    exibeTitulo: {
      type: Boolean,
      default: true
    },
    /**
     * Define se a listagem será local ou não (sem trocar a rota)
     * @values {Function}
     */
    onAdicionar: {
      type: Function,
      default: null
    },
    /**
     * Define se irá exportar dados ou não
     * @values {Function}
     */
    onExport: {
      type: Function,
      default: null
    },
    /**
     * Define se a edição será local ou não com base (sem trocar a rota)
     * @values {Function}
     */
    onEditar: {
      type: Function,
      default: null
    },
    beforeFiltrar: {
      type: Function,
      default: null
    },
    /**
     * Atributo usado para passar o ID na rota quando editar um registro
     * @values {String}
     */
    idProp: {
      type: String,
      default: 'id'
    },
    /**
     * Atributo usado para indicar se o registro está ativo ou não
     * @values {Boolean}t rue, false
     */
    ativoProp: {
      type: String,
      default: 'ativo'
    },
    /**
     * Atributo usado para definir se a lista será filtrada no inicio ou não
     * @values {Boolean} true, false
     */
    filtrarInicio: {
      type: Boolean,
      default: true
    },
    /**
     * Atributo usado para definir se a lista será editavel
     * @values {Boolean} true, false
     */
    permiteEditar: {
      type: Boolean,
      default: true
    },
    /**
     * Atributo usado para definir se a lista será editavel
     * @values {Boolean} true, false
     */
    permiteAdicionar: {
      type: Boolean,
      default: true
    },
    paginaEditar: {
      type: String,
      default: null
    },
    /**
     * Atributo usado para definir se a linha da tabela será expansível
     * @values {Boolean} true, false
     */
    abrirLinha: {
      type: Boolean,
      default: false
    },
    titulo: String,
    /**
     * Atributo usado para definir as colunas disponíveis na tabela
     * @values {Boolean} true, false
     */
    colunas: {
      type: Array,
      default: () => []
    },
    /**
     * Define se a tabela exibe fa coluna com os botões de ações
     * @values {boolean} true, false
     */
    exibeAcoes: {
      type: Boolean,
      default: true
    },
    clickItem: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      loaded: false,
      pagina: new NovaPagina(),
      pesquisa: null,
      filtroBase: null,
      primeiroFiltro: true,
      colunasLocal: [],
      paginaEditarLocal: this.paginaEditar,
      pageParams: {
        size: 10,
        page: 0
      }
    };
  },
  mounted() {
    if( this.mantemEstado ) {
      this.$router.onReady(() => {
        let { pagina } = this.$route.query;
        if (pagina != null) {
          this.pageParams.page = +pagina;
        }

        let { tamanho } = this.$route.query;
        if (tamanho != null) {
          this.pageParams.size = tamanho;
        }
      });
    }

    this.$root.$on(`${this.id}:filtrar`, () => {
      console.log('recebe evento');
      this._filtrar();
    });

    this.colunasLocal.push(...this.colunas);

    if (this.exibeAcoes == null || this.exibeAcoes) {
      this.colunasLocal.push({
        nome: this.$t('label.acoes'),
        classes: 'text-center table-75'
      });
    }

    if (this.abrirLinha) {
      this.colunasLocal.unshift({ nome: '', classes: 'text-center table-10' });
    }
    if (this.paginaEditarLocal == null) {
      this.paginaEditarLocal = `${this.$route ? this.$route.name : ''}-edicao-id`;
    }

    if (this.filtrarInicio) {
      this.onFiltrar().then(() => {
        this.primeiroFiltro = true;
      });

    }
  },
  computed: {
    noContent() {
      return this.primeiroFiltro && this.pagina.totalElements == 0;
    }
  },
  methods: {
    onTrocaPagina(item) {

      if (item.tamanho) {
        this.pageParams.page = 0;
        this.pageParams.size = item.tamanho;
      }

      this.pageParams.page = item.pagina;
      /**
       * Emite o evento trocaPagina passando a variável pagina
       */
      this.$emit('trocaPagina', item);


      this._filtrar();
    },

    onLimpar() {
      const localFiltro = this.filtro;

      Object.keys(this.filtro).forEach(function (index) {
        localFiltro[index] = null;
      });

      /**
       * Emite o evento limpar passando um array vazio
       */
      this.$emit('limpar', {});
      this.onFiltrar();
    },

    onFiltrar(filtro) {
      /**
       * Emite o evento filtrar passando um objeto filtro
       */
      this.filtroBase = filtro;
      const retorno = this.$emit('filtrar', this.filtro);
      if (retorno != false) {
        this.pesquisa = { ...this.filtro };
        return this._filtrar();
      }
    },
    _onEditar(item) {
      if (this.onEditar) {
        this.onEditar(item);
      } else {
        this.$router.push({ name: this.paginaEditarLocal, params: { id: item.id } });
      }
    },
    _filtrar() {
      if (this.$axios) {

        if (!this.$slots['filtro-comum']) {
          //Se nao tem filtro comum entao usara o filtro de "tudo"
          this.pageParams.q = this.filtroBase;
        }

        return this.$axios
            .$post(`api/${this.apiPath}`, this.pesquisa, { params: this.pageParams })
            .then(pagina => {
              this.loaded = true;
              this.primeiroFiltro = false;
              this.pagina = pagina;
              this.pagina.pageSize = this.pageParams.size;
              /**
               * Emite o evento after-filtrar passando a pagina
               */
              this.$emit('after-filtrar', pagina);
            });
      }
    },

    onAbrirLinha(item, abrir) {
      /**
       * Emite o evento abrir-linha passando duas variáveis. item, abrir
       */
      this.$emit('abrir-linha', item, abrir);
    },

    onRemoverToogle(item) {

      const dados = {
        ...item,
        titulo: this.$t('label.confirmacao'),
        mensagem: this.$tc(
            'msg.confirmacao_remover_ativar',
            item.item[this.ativoProp]
                ? this.$tc('msg.confirmacao_remover_ativar_remover')
                : this.$tc('msg.confirmacao_remover_ativar_ativar')
        )
      };

      this.$registrarModal(ModalPequeno(ModalConfirmacao, dados)).then(() => {
        (item.item[this.ativoProp]
                ? this.$axios.$delete(`api/${this.apiPath}/${item.item.id}`)
                : this.$axios.$put(`api/${this.apiPath}/${item.item.id}/ativar`)
        ).then(() => {
          this._filtrar().then(() => {
            this.notificarSucesso({
              title: this.$t('msg.sucesso'),
              message: this.$tc(
                  'msg.item_removido_ativado',
                  item.item[this.ativoProp]
                      ? this.$t('msg.item_removido_ativado_removido')
                      : this.$t('msg.item_removido_ativado_ativado')
              )
            });
          });
        });
      });
    },

    onExportClick() {
      if (this.onExport) {
        this.onExport();
      } else {

        const params = {
          colunas: (this.colunasExport && this.colunasExport.length > 0 ? this.colunasExport : this.colunas)
        }

        if(this.filtro) {
          params.filtro = this.filtro;
        }

        console.log('export', params);

        return this.$axios.post(`api/${this.apiPath}/export`, params, { responseType: 'blob' })
            .then(response => {
              const fileURL = window.URL.createObjectURL(new Blob([response.data]));

              const link = document.createElement('a');
              link.setAttribute('download', this.titulo.toLowerCase().concat('.xlsx'));
              link.href = fileURL;
              document.body.appendChild(link);
              link.click();
              link.remove();
            });
      }
    },
    onAdicionarClick() {
      if (this.onAdicionar) {
        this.onAdicionar();
      } else {
        this.$router.replace({ name: this.paginaEditarLocal });
      }
    },
    abreLinha(item) {
      this.$refs.table.onAbrirLinha(item);
    },
    onOrdenar(campo) {
      if (campo.ordem == null) {
        this.pageParams.sort = null;
      } else {
        this.pageParams.sort = `${campo.campo},${campo.ordem}`;
      }
      /**
       * Emite o evento ordenar passando um objeto campo
       */
      this.$emit('ordenar', campo);
      this._filtrar();
    },

    onClickItem(item, click) {
      /**
       * Emite o evento click-item passando um item e um click
       */
      this.$emit('click-item', item, click);
    }
  },
  notifications: {
    notificarSucesso: {
      type: 'success'
    }
  }
};
</script>

<style>
.btn-add-outline {
  height: 42px;
  border-radius: 4px;
  padding-top: 0.6rem;
}
</style>
